import { TabContext, TabList, TabPanel } from '@mui/lab'
import { Box, Grid, Tab } from '@mui/material'
import React, { useState } from 'react'
import PolicySubTab from './PolicySubTab'
import { PolicyData } from './PolicyData'
import {TermsAndConditionsData } from './TermsAndConditionsData'
import { CancellationData } from './CancellationData'


function PolicyTab() {
  const [value, setValue] = useState('1')

  const handleChange = (event, newValue) => {
    setValue(newValue);
  }
  return (
    <Grid container>
      <Grid item className='tableContainer' xs={12}>
        <Box className='contentBoxStyle marginBlock10'>
          <TabContext value={value}>
            <Grid container
              className="tabBoxStyle"
              direction='row'
              justifyContent='space-between'
              alignItems='center'>
              <Grid item>
                <TabList xs={6}
                  onChange={handleChange}
                  aria-label='lab API tabs example'
                >
                  <Tab label="Terms & Conditions" value='1' className='tabStyle' />
                  <Tab label="Cancellation Policy" value='2' className='tabStyle' />
                  <Tab label="About" value='3' className='tabStyle' />
                  <Tab label="Your Rating" value='4' className='tabStyle' />
                </TabList>
              </Grid>
            </Grid>
            <TabPanel value='1' className='tabPanelStyle'> <PolicySubTab policyTab={TermsAndConditionsData} /></TabPanel>
            <TabPanel value='2' className='tabPanelStyle'> <PolicySubTab policyTab={CancellationData} /></TabPanel>
            <TabPanel value='3' className='tabPanelStyle'> <PolicySubTab policyTab={PolicyData} /></TabPanel>
            <TabPanel value='4' className='tabPanelStyle'> <PolicySubTab policyTab={PolicyData} /></TabPanel>
          </TabContext>

        </Box>

      </Grid>

    </Grid>
  )
}

export default PolicyTab
